import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

const maxRetries = 2;

const baseQuery = retry(
  fetchBaseQuery({
    baseUrl: process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE,
  }),
  { maxRetries }
);

export const debounceOverrideAPI = createApi({
  reducerPath: "debounceOverrideAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetDebounceOverrides"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET DEBOUNCE OVERRIDES BY BANK */
    getDebounceOverrides: builder.query({
      query: (body: any) => ({
        url: `/debounce-overrides/?page=1&limit=9999&filter_target=bank_id&filter=${body.bankId}`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetDebounceOverrides"],
    }),
    //* *********************************************************** */
    //* POST DEBOUNCE OVERRIDE */
    postDebounceOverride: builder.mutation({
      query: (body: any) => ({
        url: `/debounce-overrides/`,
        method: "post",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetDebounceOverrides"],
    }),
    //* *********************************************************** */
    //* PUT DEBOUNCE OVERRIDE */
    putDebounceOverride: builder.mutation({
      query: (body: any) => ({
        url: `/debounce-overrides/${body.id}`,
        method: "put",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetDebounceOverrides"],
    }),
    //* *********************************************************** */
    //* DELETE DEBOUNCE OVERRIDE */
    deleteDebounceOverride: builder.mutation({
      query: (body: any) => ({
        url: `/debounce-overrides/${body.id}`,
        method: "delete",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetDebounceOverrides"],
    }),
  }),
});

export const {
  useLazyGetDebounceOverridesQuery,
  usePostDebounceOverrideMutation,
  usePutDebounceOverrideMutation,
  useDeleteDebounceOverrideMutation,
} = debounceOverrideAPI;
